<div class="paneContentNoPadding container">
	@if (!userRecordingAssessments.length) {
		<div class="noAssessmentsYet">
			<div class="text">
				{{ T.ASSESSMENT_PANE_NO_ASSESSMENTS_TAKEN | translate }}
			</div>
			<div class="createNewAssessment">
				<sim-button
					(onClick)="addAssessment()"
					[icon]="{fontSet: 'fad', fontIcon: 'fa-file-plus'}"
					[label]="T.ASSESSMENT_PANE_ADD_ASSESSMENT"
					color="accent"
				/>
			</div>
		</div>
	}

	@if (userRecordingAssessments.length) {
		<div class="h-100">
			<mat-tab-group
				color="accent"
				class="fullHeight h-100 noOverflow"
				[(selectedIndex)]="selectedTabIndex"
				[mat-stretch-tabs]="false"
			>
				@for (
					userRecordingAssessment of userRecordingAssessments;
					track TrackByMethods.trackById(i, userRecordingAssessment);
					let i = $index
				) {
					<mat-tab *ngVar="assessmentCandidatesPerAssessment.get(userRecordingAssessment.id) as appraises">
						<ng-template mat-tab-label>
							<div class="assessmentLabelState">
								@if (
									userRecordingAssessment.state !== AssessmentState.InProgress &&
									userRecordingAssessment.state !== AssessmentState.Aborted
								) {
									<i class="fad fa-check"></i>
								}
								@if (userRecordingAssessment.state === AssessmentState.InProgress) {
									<i class="fad fa-tasks"></i>
								}
								@if (userRecordingAssessment.state === AssessmentState.Aborted) {
									<i class="fad fa-minus-circle"></i>
								}
							</div>
							<div
								*ngVar="getAssessmentName(userRecordingAssessment) as assessmentName"
								[matTooltip]="userRecordingAssessment?.name"
								matTooltipClass="primary"
								matTooltipPosition="above"
							>
								{{ assessmentName }}
							</div>
							<sim-horizontal-user-bubbles [users]="appraises" />
						</ng-template>
						<div class="contentForAssesment">
							<div class="controlAndMetaCon">
								<div class="header">
									<div class="appraiseCon">
										<div class="appraiseH">
											{{ T.ASSESSMENT_PANE_ASSESSMENT_CANDIDATE | translate }}
										</div>
										<div class="appraiseV">
											@for (appraise of appraises; track TrackByMethods.trackById($index, appraise)) {
												<div class="fullName">
													{{ appraise?.fullname }}
												</div>
											}
										</div>
									</div>
									@if (isInArchive) {
										<button
											class="detailsLink"
											[routerLink]="[
												'/web-manager/list/assessments/user-recording-assessments/' + userRecordingAssessment.id,
											]"
											mat-button
											color="accent"
										>
											{{ T.ASSESSMENT_PANE_OPEN_DETAILS | translate }}
										</button>
									}
								</div>
							</div>
							<div class="assessmentItemsHolder">
								<div class="assessmentItems" (scroll)="onScroll()">
									<sim-assessment-answer-panel
										#assessmentPanelComponent
										[variant]="AssessmentAnswerPanelVariant.RecordingView"
										[isInArchive]="isInArchive"
										[assessable]="userRecordingAssessment"
										[mode]="
											userRecordingAssessment.state === AssessmentState.InProgress
												? AssessablePanelMode.Answer
												: AssessablePanelMode.View
										"
										(onJumpToItem)="jumpToItem.emit($event)"
									/>
									@if (assessmentPanelComponent.isFormInitialized()) {
										<sim-assessment-examiner-note
											[mode]="
												userRecordingAssessment.state === AssessmentState.InProgress
													? AssessablePanelMode.Answer
													: AssessablePanelMode.View
											"
											[note]="assessmentPanelComponent.note"
											(noteChange)="assessmentPanelComponent.handleNoteChange($event)"
										/>
									}
								</div>
							</div>
							@if (userRecordingAssessment) {
								<div class="bottomHolder">
									<button mat-button color="accent" (click)="addAssessment()" class="addAssessmentBtn">
										<i class="fad fa-file-plus"></i>
										{{ T.ASSESSMENT_PANE_ADD_ASSESSMENT | translate }}
									</button>
									<sim-button
										(onClick)="abortAssessment(userRecordingAssessment)"
										[disabled]="userRecordingAssessment.state !== AssessmentState.InProgress"
										[icon]="{
											fontSet: 'fad',
											fontIcon: 'fa-times',
										}"
										[label]="T.ASSESSMENT_PANE_ABORT_BUTTON"
										style="margin-left: auto; margin-right: 15px"
										color="warn"
									/>
									<sim-button
										(onClick)="
											userRecordingAssessment.state === AssessmentState.InProgress
												? finishAssessment(userRecordingAssessment)
												: reopenAssessment(userRecordingAssessment)
										"
										[icon]="
											userRecordingAssessment.state === AssessmentState.InProgress
												? {
														fontSet: 'fad',
														fontIcon: 'fa-check-double',
													}
												: {
														fontSet: 'fad',
														fontIcon: 'fa-lock-open',
													}
										"
										[disabled]="!assessmentPanelComponent.isFormValid()"
										[label]="
											userRecordingAssessment.state === AssessmentState.InProgress
												? T.ASSESSMENT_PANE_FINISH_BUTTON
												: T.ASSESSMENT_REVIEW_REOPEN_BUTTON
										"
									/>
								</div>
							}
						</div>
					</mat-tab>
				}
			</mat-tab-group>
		</div>
	}
</div>
